
export function useRouteHistory() {
 

  function isDifferent(link: string) {
    const currentUrl = new URL(window.location.href)
    const linkUrl = new URL(link, window.location.href)

    return (
      currentUrl.pathname !== linkUrl.pathname ||
      currentUrl.search !== linkUrl.search ||
      currentUrl.hash !== linkUrl.hash
    )
  }

  function getCurrent() {
    return window.location.href + window.location.hash;
  }

  
  function pushHash(hash: string) {
    // If an empty string is passed, we want to completely remove the fragment
    if (hash === '') {
      // Build URL without the hash fragment
      const urlWithoutHash = window.location.pathname + window.location.search;

      // Skip if nothing would change
      if (!isDifferent(urlWithoutHash)) return;

      // Push new state without the hash
      window.history.pushState(
        JSON.parse(JSON.stringify(window.history.state || {})),
        '',
        urlWithoutHash
      );
      return;
    }

    // Ensure the hash string starts with "#" (e.g., "#section")
    hash = hash.startsWith('#') ? hash : `#${hash}`;

    // Skip if the target hash is identical to the current one
    if (!isDifferent(hash)) return;

    // Push new state with the desired hash
    window.history.pushState(
      JSON.parse(JSON.stringify(window.history.state || {})),
      '',
      hash
    );
  }

  function push(link: string) {
    if(!isDifferent(link)) return;
    window.history.pushState(JSON.parse(JSON.stringify(window.history.state || {})), '', link);
  }
 
  function replace(link: string) {
    if(!isDifferent(link)) return;
    window.history.replaceState(JSON.parse(JSON.stringify(window.history.state || {})), '', link);
  }

  return {
    push,
    pushHash,
    replace,
  }
}